export const NEW_BOOKING_PAGES = [
  "/new-booking",
  "/new-booking/booking-passenger-details",
  "/new-booking/booking-summary",
  "/new-booking/airport-details"
];